import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import RootPage from '@/pages/Root.vue';
import NotFoundPage from '@/pages/NotFound.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/profile/portfolio-view/:outer_token',
    name: 'root',
    component: RootPage,
  },
  {
    path: '/not_found',
    name: 'not_found',
    component: NotFoundPage,
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFoundPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
export { routes };
